export class Category {
  id: number;
  name: string;
  code: string;
}